// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8 ? "6b857348" : chunkId) + "." + {"8":"384527b8eea0566c","954":"11be4fe435d2d845"}[chunkId] + ".js";
};